import axios from "axios";

const state = {
	blinking: false,
	settings: {},
	notifications: {
		loading: false,
		data: [],
		meta: {
			// PAGINATION
			current_page: null,
			from: null,
			last_page: null,
			links: null,
			path: null,
			per_page: null,
			to: null,
			total: null,
		},
	},
	unreadNotifications: {
		loading: false,
		data: [],
		meta: {
			// PAGINATION
			current_page: null,
			from: null,
			last_page: null,
			links: null,
			path: null,
			per_page: null,
			to: null,
			total: null,
		},
	},
	readNotifications: {
		loading: false,
		data: [],
		meta: {
			// PAGINATION
			current_page: null,
			from: null,
			last_page: null,
			links: null,
			path: null,
			per_page: null,
			to: null,
			total: null,
		},
	},
	pendingNotifications: []
};

const getters = {
	settings: (state) => {
		return state.settings;
	},
	notifications: (state) => {
		return state.notifications.data;
	},
	unreadNotifications: (state) => {
		return state.unreadNotifications.data
	},
	readNotifications: (state) => {
		return state.readNotifications.data
	},
	meta: (state) => {
		return state.notifications.meta;
	},
	unreadMeta: (state) => {
		return state.unreadNotifications.meta;
	},
	readMeta: (state) => {
		return state.readNotifications.meta;
	},
	loadingNotifications: (state) => {
		return state.notifications.loading;
	},
	loadingUnreadNotifications: (state) => {
		return state.unreadNotifications.loading;
	},
	loadingReadNotifications: (state) => {
		return state.readNotifications.loading;
	},
	pendingNotifications: (state) => {
		return state.pendingNotifications;
	},
	blinking: (state) => {
		return state.blinking;
	}
};

const mutations = {
	setSettings(state, payload) {
		state.settings = payload;
	},
	setNotifications(state, payload) {
		state.notifications.data = payload;
	},
	setNotificationsMeta(state, payload) {
		state.notifications.meta = payload;
	},
	setUnreadNotifications(state, payload) {
		state.unreadNotifications.data = payload;
	},
	setReadNotifications(state, payload) {
		state.readNotifications.data = payload;
	},
	setUnreadNotificationsMeta(state, payload) {
		state.unreadNotifications.meta = payload;
	},
	setReadNotificationsMeta(state, payload) {
		state.readNotifications.meta = payload;
	},
	setNotification(state, payload) {
		const indexAll = state.notifications.data.findIndex(x => x.id == payload.id);
		if(indexAll != -1) {
			Object.keys(payload).forEach(key => {
				if(key != 'id') {
					state.notifications.data[indexAll][key] = payload[key];
				}
			});
		}

		const indexUnread = state.unreadNotifications.data.findIndex(x => x.id == payload.id);
		if(indexUnread != -1) {
			Object.keys(payload).forEach(key => {
				if(key != 'id') {
					state.unreadNotifications.data[indexUnread][key] = payload[key];
				}
			});
		}

		const indexRead = state.readNotifications.data.findIndex(x => x.id == payload.id);
		if(indexRead != -1) {
			Object.keys(payload).forEach(key => {
				if(key != 'id') {
					state.readNotifications.data[indexRead][key] = payload[key];
				}
			});
		}
	},
	addNotification(state, notification) {
		let idx = state.notifications.data.findIndex(x => x.id == notification.id);
		if(idx == -1) {
			state.notifications.data.push(notification);
		}
	},
	addUnreadNotification(state, notification) {
		let idx = state.unreadNotifications.data.findIndex(x => x.id == notification.id);
		if(idx == -1) {
			state.unreadNotifications.data.push(notification);
		}
	},
	addReadNotification(state, notification) {
		let idx = state.readNotifications.data.findIndex(x => x.id == notification.id);
		if(idx == -1) {
			state.readNotifications.data.push(notification);
		}
	},
	removeNotification(state, notification) {
		let index = state.notifications.data.findIndex(x => x.id == notification.id)
		if(index != -1) {
			state.notifications.data.splice(index, 1);
			if(state.notifications.meta.total > 0) {
				state.notifications.meta.total--;
			}
		}

		if(!notification.watched_at) {
			index = state.unreadNotifications.data.findIndex(x => x.id == notification.id);
			if(index != -1) {
				state.unreadNotifications.data.splice(index, 1);
				if(state.unreadNotifications.meta.total > 0) {
					state.unreadNotifications.meta.total--;
				}
			}
		}
		else {
			index = state.readNotifications.data.findIndex(x => x.id == notification.id);
			if(index != -1) {
				state.readNotifications.data.splice(index, 1);
				if(state.readNotifications.meta.total > 0) {
					state.readNotifications.meta.total--;
				}
			}
		}
	},
	incrementNotifications(state) {
		state.notifications.meta.total++;
	},
	incrementUnreadNotifications(state) {
		state.unreadNotifications.meta.total++;
	},
	incrementReadNotifications(state) {
		state.readNotifications.meta.total++;
	},

	decrementNotifications(state) {
		if(state.notifications.meta.total > 0) {
			state.notifications.meta.total--
		}

	},
	decrementUnreadNotifications(state) {
		if(state.unreadNotifications.meta.total > 0) {
			state.unreadNotifications.meta.total--
		}

	},
	decrementReadNotifications(state) {
		if(state.readNotifications.meta.total > 0) {
			state.readNotifications.meta.total--
		}

	},

	setNotificationsLoading(state, payload) {
		state.notifications.loading = payload;
	},
	setUnreadNotificationsLoading(state, payload) {
		state.unreadNotifications.loading = payload;
	},
	setReadNotificationsLoading(state, payload) {
		state.readNotifications.loading = payload;
	},
	clearNotifications(state) {
		state.notifications = {
			loading: false,
			data: [],
			meta: {
				current_page: null,
				from: null,
				last_page: null,
				links: null,
				path: null,
				per_page: null,
				to: null,
				total: null,
			},
		}
	},
	addPendingNotification(state, payload) {
		if(state.pendingNotifications.indexOf(x => x.id == payload.id) == -1) {
			state.pendingNotifications.push(payload);
		}
	},
	removePendingNotification(state, payload) {
		let index = state.pendingNotifications.findIndex(x => x.id == payload.id);
		if(index != -1) {
			state.pendingNotifications.splice(index, 1);
		}
	},
	setPendingNotifications(state, payload) {
		state.pendingNotifications = payload;
	},
	setBlinking(state, payload) {
		state.blinking = payload;
	},
	setAllWatched(state) {
		const now = this._vm.$moment();
		state.notifications.data.forEach((x, index) => {
			if(!x.watched_at) {
				state.notifications.data[index].watched_at = now;
			}
		});
		state.unreadNotifications.data.forEach((x, index) => {
			if(!x.watched_at) {
				state.unreadNotifications.data[index].watched_at = now;
				if(state.unreadNotifications.meta.total > 0) {
					state.unreadNotifications.meta.total--
				}
			}
		});
		state.readNotifications.data.forEach((x, index) => {
			if(!x.watched_at) {
				state.readNotifications.data[index].watched_at = now;
			}
		})
	}
};

const actions = {

	async getSettings({ commit }) {
		await axios
			.get("notification-settings")
			.then((response) => {
				const settings = response.data.data;
				commit("setSettings", settings);
			})
			.catch((error) => {
				console.log("GET NOTIFICATIONS-SETTINGS ERROR", error);
			});
	},



	async getNotifications({ commit }, payload) {

		if(payload && payload.watched == 'no') {
			commit('setUnreadNotificationsLoading', true);
		}
		else if(payload && payload.watched == 'yes') {
			commit('setReadNotificationsLoading', true);
		}
		else {
			commit('setNotificationsLoading', true);
		}
		await axios
			.get("notifications", {
				params: payload
			})
			.then((response) => {
				let append = false;
				if(payload.page && payload.page > 1) {
					append = true;
				}

				if(payload && payload.watched) {
					if(payload.watched == 'no') {
						if(append) {
							response.data.data.forEach(x => {
								commit('addUnreadNotification', x);
							})
						}
						else {
							commit("setUnreadNotifications", response.data.data);
						}
						commit('setUnreadNotificationsMeta', response.data.meta);
					}
					else if(payload.watched == 'yes') {
						if(append) {
							response.data.data.forEach(x => {
								commit('addReadNotification', x);
							})
						}
						else {
							commit("setReadNotifications", response.data.data);
						}
						commit('setReadNotificationsMeta', response.data.meta);
					}
					else {
						if(append) {
							response.data.data.forEach(x => {
								commit('addNotification', x);
							})
						}
						else {
							commit("setNotifications", response.data.data);
						}
						commit('setNotificationsMeta', response.data.meta);
					}
				}
				else {
					if(append) {
						response.data.data.forEach(x => {
							commit('addNotification', x);
						})
					}
					else {
						commit("setNotifications", response.data.data);
					}
					commit('setNotificationsMeta', response.data.meta);
				}
			})
			.catch((error) => {
				console.log("GET NOTIFICATIONS ERROR", error);
			});

		if(payload && payload.watched == 'no') {
			commit('setUnreadNotificationsLoading', false);
		}
		else if(payload && payload.watched == 'yes') {
			commit('setReadNotificationsLoading', false);
		}
		else {
			commit('setNotificationsLoading', false);
		}
	},

	/* eslint-disable */
	async getNotification({state}, id) {
		let res = {};
		await axios.get(`notifications/${id}`)
			.then(response => {
				res = {
					success: true,
					data: response.data.data,
					error: false
				}
			})
			.catch(error => {
				res = {
					success: false,
					data: null,
					error: error
				}
			})

		return res;
	},
	/* eslint-enable */

	async updateStatus({commit}, payload) {
		let updateData = {};
		const now = this._vm.$moment().local();
		if(payload && payload.action) {
			if(payload.action == 'watched') {
				updateData.watched_at = now;
			}
			if(payload.action == 'unwatched') {
				updateData.watched_at = null;
			}
			if(payload.action == 'clicked') {
				updateData.clicked_at = now;
			}
			if(payload.action == 'unclicked') {
				updateData.clicked_at = null;
			}
		}
		let res = {};
		await axios.post('notifications/update-statuses', {
			action: payload.action,
			notification_ids: payload.notification_ids
		})
		.then(response => {
			payload.notification_ids.forEach(x => {
				updateData.id = x;
				commit('setNotification', updateData);

				if(payload.action == 'watched') {
					// commit('increment')
				}
			});

			res = {
				success: true,
				data: response.data.data,
				error: false
			}
		})
		.catch(error => {
			res = {
				success: false,
				data: null,
				error: error
			}
			this._vm.$snackbar.error({error})
		})
		return res;
	},
	async saveSettings({ commit }, payload) {
		let res = {};
		await axios
			.post("notification-settings", payload)
			.then((response) => {
				res = {
					success: true,
				};
				const settings = response.data.data;
				commit("setSettings", settings);
			})
			.catch((error) => {
				console.log("POST NOTIFICATIONS-SETTINGS ERROR", error);
				res = {
					success: false,
				};
			});
		return res;
	},
	async deleteNotification({commit}, payload) {
		let res = {}
		await axios.delete('/notifications/' + payload.id)
			.then((response) => {

				console.log("DELETED", response)
				res = {
					success: true,
					data: null,
					error: false
				}
			})
			.catch(error => {
				console.log("ERROR", error)
				res = {
					success: false,
					error: error,
					data: null
				}
			})
			if(res.success) [
				commit('removeNotification', payload)
			]
		return res;
	},
	async markAllWatched({commit}) {
		let res = {};
		await axios.post('notifications/set-all-watched')
			.then(response => {
				commit('setAllWatched');
				res = {
					success: true,
					data: response.data.data,
					error: false
				}
			})
			.catch(error => {
				res = {
					success: false,
					data: null,
					error: error
				}
			})
		return res;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
